module.exports = __webpack_public_path__ + "img/1.4a512e40.jpg";